export const createFilterPlaceholders = () => ({
  type: '類型篩選',
  operator: '價格調整篩選',
  periodStatus: '期間狀態篩選',
  state: '啟用篩選',
})

export const createFilterOptions = () => ({
  type: [{ label: '連續住宿', value: 'stay' }, { label: '期間限定', value: 'period' }],
  operator: [{ label: '加價', value: '+' }, { label: '減價', value: '-' }],
  periodStatus: [{ label: '進行中', value: 'active' }, { label: '已過期', value: 'expired' }],
  state: [{ label: '啟用', value: 1 }, { label: '關閉', value: 0 }],
})

export const createTypeTextMap = () => ({
  stay: '連續住宿',
  period: '期間限定',
})

export const createDialogTypeOptions = () => [{ label: '連續住宿', value: 'stay' }, { label: '期間限定', value: 'period' }]

export const createUiText = () => ({
  pageTitle: '房價調整',
  pageSubTitle: '管理連住折扣、單次期間與房價加減設定',
  createButton: '新增房價調整',
})

export const createTableLabels = () => ({
  roomTypeLabel: '適用房型：',
  periodLabel: '期間：',
  itemName: '項目名稱',
  type: '適用類型',
  adjustValue: '價格調整',
  minNight: '連住天數',
  periodStatus: '期間狀態',
  actions: '操作',
  enabled: '啟用',
  edit: '編輯',
  delete: '刪除',
  expired: '已過期',
  noChange: '無變動',
  empty: '-',
  emptySymbol: '－',
  nightSuffix: '晚以上',
})

export const createDialogLabels = () => ({
  createTitle: '新增房價調度',
  editTitle: '編輯房價調度',
  title: '優惠標題',
  titlePlaceholder: '請輸入優惠標題',
  minNight: '連住天數',
  type: '類型',
  valueType: '優惠類型',
  value: '金額',
  roomType: '適用房型',
  roomTypePlaceholder: '請選擇房型',
  dateRange: '期間設定',
  startDate: '開始日期',
  endDate: '結束日期',
  cancel: '取消',
  save: '儲存',
})
